const imp = () => import(/* webpackChunkName: "loadSprite_bd"*/  "../sprite/loadSprite_bd");
const loadMap_bd: { [key: string]: () => Promise<any> } = {
  "Icon-bd-Activity": imp,
  "Icon-bd-Amount": imp,
  "Icon-bd-Appendix": imp,
  "Icon-bd-Approve": imp,
  "Icon-bd-Associateddocuments": imp,
  "Icon-bd-Associatedprojects": imp,
  "Icon-bd-Associatedtasks": imp,
  "Icon-bd-Attendance": imp,
  "Icon-bd-Bookmarkpage": imp,
  "Icon-bd-Breakdown": imp,
  "Icon-bd-Browse": imp,
  "Icon-bd-Business": imp,
  "Icon-bd-Button": imp,
  "Icon-bd-Calculation": imp,
  "Icon-bd-Carousel": imp,
  "Icon-bd-Checkbox": imp,
  "Icon-bd-Childtable": imp,
  "Icon-bd-Contactperson": imp,
  "Icon-bd-Descriptiontext": imp,
  "Icon-bd-Departmentselection": imp,
  "Icon-bd-Divisionselection": imp,
  "Icon-bd-Dropdownbox": imp,
  "Icon-bd-Dropdownmenu": imp,
  "Icon-bd-Formdata": imp,
  "Icon-bd-Geographiclocation": imp,
  "Icon-bd-Grouping": imp,
  "Icon-bd-IDcard": imp,
  "Icon-bd-Inputbox": imp,
  "Icon-bd-Mail": imp,
  "Icon-bd-MobilePhone": imp,
  "Icon-bd-Numberinputbox": imp,
  "Icon-bd-Optionmatrix": imp,
  "Icon-bd-Order": imp,
  "Icon-bd-Performance": imp,
  "Icon-bd-Personnelselection": imp,
  "Icon-bd-Pictureradio": imp,
  "Icon-bd-Pictureselection": imp,
  "Icon-bd-Quotation": imp,
  "Icon-bd-Roleselection": imp,
  "Icon-bd-Selectbox": imp,
  "Icon-bd-Singlebox": imp,
  "Icon-bd-Tablelayout": imp,
  "Icon-bd-Textbox": imp,
  "Icon-bd-Threecolumns": imp,
  "Icon-bd-Timecontrol": imp,
  "Icon-bd-Treecontrol": imp,
  "Icon-bd-Twocolumns": imp,
  "Icon-bd-bill": imp,
  "Icon-bd-clue": imp,
  "Icon-bd-contract": imp,
  "Icon-bd-customer": imp,
  "Icon-bd-date": imp,
  "Icon-bd-ebuilder": imp,
  "Icon-bd-fold": imp,
  "Icon-bd-integrated": imp,
  "Icon-bd-opponent": imp,
  "Icon-bd-picture": imp,
  "Icon-bd-product": imp,
  "Icon-bd-progressbar": imp,
  "Icon-bd-report": imp,
  "Icon-bd-schedule": imp,
  "Icon-bd-score": imp,
  "Icon-bd-selectionpersonnel": imp,
  "Icon-bd-serialnumber": imp,
  "Icon-bd-sign": imp,
  "Icon-bd-splitline": imp,
  "Icon-bd-telephone": imp,
  "Icon-ziduan": imp,
  "Icon-buju": imp,
  "Icon-yiyong": imp,
  "Icon-bd-Daterange": imp,
  "Icon-muban": imp,
  "Icon-tongji": imp,
  "Icon-bd-Dropdown1": imp,
  "Icon-bd-Single1": imp,
  "Icon-bd-Single2": imp,
  "Icon-bd-Single3": imp,
  "Icon-bd-Dropdown2": imp,
  "Icon-bd-Comment": imp,
  "Icon-bd-TicketNo": imp,
  "Icon-bd-QRcode2": imp,
  "Icon-bd-QRcode1": imp,
  "Icon-bd-collector": imp,
  "Icon-bd-Tickettitle": imp,
  "Icon-bd-fillinperson": imp,
  "Icon-bd-Reportingname": imp,
  "Icon-bd-distributed": imp,
  "Icon-bd-officialdocument": imp,
  "Icon-bd-Navigationpanel": imp,
  "Icon-bd-Approval-comments": imp,
  "Icon-dzl": imp,
  "Icon-bd-remind": imp,
  "Icon-bd-repeat": imp,
  "Icon-bd-login": imp,
  "Icon-bd-officialcomments": imp,
  "Icon-bd-CalendarHeatmap": imp,
  "Icon-bd-facetmap": imp,
  "Icon-bd-wordcloud": imp,
  "Icon-bd-bulletchart": imp,
  "Icon-bd-Make-a-note-of-it": imp,
  "Icon-bd-Editingprohibited": imp,
  "Icon-bd-Required": imp,
  "Icon-bd-edit": imp,
  "Icon-bd-hide": imp,
  "Icon-bd-readonly": imp,
  "Icon-bd-text2": imp,
  "Icon-bd-btn-1": imp,
  "Icon-bd-btn": imp,
  "Icon-bd-checked-1": imp,
  "Icon-bd-footerID-w": imp,
  "Icon-bd-checked": imp,
  "Icon-bd-footerID": imp,
  "Icon-bd-formend-w": imp,
  "Icon-bd-formstart-w": imp,
  "Icon-bd-formstart": imp,
  "Icon-bd-formend": imp,
  "Icon-bd-groupend": imp,
  "Icon-bd-groupstart-w": imp,
  "Icon-bd-groupstart": imp,
  "Icon-bd-headerID-w": imp,
  "Icon-bd-headerID": imp,
  "Icon-bd-listend-w": imp,
  "Icon-bd-listend": imp,
  "Icon-bd-liststart": imp,
  "Icon-bd-selectall-1": imp,
  "Icon-bd-liststart-w": imp,
  "Icon-bd-selectall": imp,
  "Icon-bd-total-1": imp,
  "Icon-bd-total": imp,
  "Icon-bd-groupend-w": imp,
  "Icon-bd-Personnelscope": imp,
  "Icon-bd-cascade": imp,
  "Icon-bd-Initializedetails": imp,
  "Icon-bd-Scheduletitle": imp,
  "Icon-bd-columnheader": imp,
  "Icon-bd-propertysettings": imp,
  "Icon-bd-serialnumber2": imp,
  "Icon-bd-datetime": imp,
  "Icon-bd-Combinationformula": imp,
  "Icon-bd-Insertfunction": imp,
  "Icon-bd-detailform": imp,
  "Icon-bd-governmentunit": imp,
  "Icon-bd-information": imp,
  "Icon-bd-logic": imp,
  "Icon-bd-math": imp,
  "Icon-bd-putaway": imp,
  "Icon-bd-tabs": imp,
  "Icon-bd-text": imp,
}
export default loadMap_bd;
